<template>
	<div 
	class="form-group" 
	:class="formGroupClass">
	
		<form-label 
		v-if="name" 
		:class="labelClass"
		:for="id"
		v-html="$sanitize(name)" />

		<v-select 
		v-bind="$attrs"
		@search="$emit('search', $event)"
		@input="input" 
		:value="val"
		:options="options"
		:class="{
			'is-invalid': $hasErrors(errors)
		}">

			<template #selected-option="option">
				<slot name="selected-option" v-bind="{option}"></slot>
			</template>
			
			<template slot="option" slot-scope="option">
				<slot name="option" v-bind="{option}"></slot>
			</template>

			<template slot="no-options">
				<slot name="no-options">
					Rechercher ...
				</slot>
		    </template>

		</v-select>

		<form-errors v-bind="{errors}" />
		
	</div>
</template>

<script>

	import { mapState } from 'vuex'

	export default {

		inheritAttrs: false,

		props: {
			id: {
				type: String,
				default() {
					return `input-select-datalist-${this._uid}`
				},
			},

			datalist: {
				type: String,
				default: ''
			},

			formGroupClass: {
				type: [String, Array],
				default: ''
			},

			labelClass: {
				type: String,
				default: ''
			},
			
			errors: {
  				type: String,
 				default: "",
  			},

			value: [String, Number, Boolean, Array, Object],
			name: String,
			sublabel: String

		},

		data() {
			return {
				options: []
			}
		},

		computed: {

			val() {
				return this.value
			}

		},

		methods: {

			input(value) {
				this.$emit('input', value)
			}

		},

		mounted() {
			axios.get('/api/datalists/'+this.datalist)
			.then(response => {
				this.options = _.map(response.data, (value, key) => {
					return {
						value: key,
						label: _.isObject(value) ? value.name : value,
						data: value
					}
				})
			}) 
		}
	}
</script>
